// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      CONSENT_TITLE: "Consent Required",
      CONSENT_TEXT: "Please review and accept our Privacy Policy and Terms of Service before using WellSyncer.",
      RESEARCH_OPTIN: "I agree to allow my de-identified data to be used for research and app improvement.",
      ACCEPT_BUTTON: "Accept & Continue",
      REVOKE_BUTTON: "Revoke Consent",
      UPDATE_BUTTON: "Update Consent"
    }
  },
  pt: {
    translation: {
      CONSENT_TITLE: "Consentimento Necessário",
      CONSENT_TEXT: "Por favor, reveja e aceite nossa Política de Privacidade e Termos de Serviço antes de usar o WellSyncer.",
      RESEARCH_OPTIN: "Concordo que meus dados desidentificados sejam usados para pesquisa e melhoria do aplicativo.",
      ACCEPT_BUTTON: "Aceitar e Continuar",
      REVOKE_BUTTON: "Revogar Consentimento",
      UPDATE_BUTTON: "Atualizar Consentimento"
    }
  },
  es: {
    translation: {
      CONSENT_TITLE: "Consentimiento Requerido",
      CONSENT_TEXT: "Por favor, revise y acepte nuestra Política de Privacidad y Términos de Servicio antes de usar WellSyncer.",
      RESEARCH_OPTIN: "Acepto que mis datos desidentificados se utilicen para investigación y mejora de la aplicación.",
      ACCEPT_BUTTON: "Aceptar y Continuar",
      REVOKE_BUTTON: "Revocar Consentimiento",
      UPDATE_BUTTON: "Actualizar Consentimiento"
    }
  },
  fr: {
    translation: {
      CONSENT_TITLE: "Consentement Requis",
      CONSENT_TEXT: "Veuillez examiner et accepter notre Politique de Confidentialité et nos Conditions d’Utilisation avant d’utiliser WellSyncer.",
      RESEARCH_OPTIN: "J’accepte que mes données désidentifiées soient utilisées pour la recherche et l’amélioration de l’application.",
      ACCEPT_BUTTON: "Accepter et Continuer",
      REVOKE_BUTTON: "Révoquer le Consentement",
      UPDATE_BUTTON: "Mettre à Jour le Consentement"
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
